/**
 * Meta Pixel + Conversions API — yalnız pazarlama çerez onayıyla çalışır.
 * Tarayıcı olayı ve sunucu olayı AYNI event_id ile gider; Meta çift saymaz.
 */
import { api } from "@/lib/api";
import { getConsent } from "@/lib/analytics";

let pixelId = null;
let loaded = false;
let configPromise = null;

const marketingAllowed = () => !!getConsent()?.marketing;

const readCookie = (name) =>
  document.cookie.split("; ").find((c) => c.startsWith(`${name}=`))?.split("=")[1] || null;

const loadScript = (id) => {
  if (loaded || !id) return;
  const fbq = function (...args) {
    fbq.callMethod ? fbq.callMethod(...args) : fbq.queue.push(args);
  };
  fbq.queue = [];
  fbq.loaded = true;
  fbq.version = "2.0";
  window.fbq = window.fbq || fbq;
  window._fbq = window._fbq || window.fbq;
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(s);
  window.fbq("init", id);
  window.fbq("track", "PageView");
  loaded = true;
};

/** Onay varsa Pixel'i yükler. Onay yoksa hiçbir istek yapılmaz. */
export const initMetaPixel = async () => {
  if (!marketingAllowed() || loaded) return;
  if (!configPromise) configPromise = api.get("/growth/meta/pixel-config").then((r) => r.data);
  try {
    const config = await configPromise;
    pixelId = config?.pixel_id || null;
    if (pixelId) loadScript(pixelId);
  } catch {
    pixelId = null;
  }
};

const uuid = () =>
  (window.crypto?.randomUUID?.() ||
    `evt_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`);

/**
 * Dönüşüm olayını hem tarayıcıya hem sunucuya aynı event_id ile gönderir.
 * eventId verilirse (örn. sipariş no) tekrar gönderimlerde de tekilleştirilir.
 */
export const trackMeta = async (eventName, data = {}, eventId) => {
  if (!marketingAllowed()) return { sent: false, reason: "consent_required" };
  await initMetaPixel();
  if (!pixelId) return { sent: false, reason: "pixel_not_configured" };
  const id = eventId || uuid();
  window.fbq?.("track", eventName, data, { eventID: id });
  try {
    const res = await api.post("/growth/meta/events", {
      event_name: eventName,
      event_id: id,
      event_source_url: window.location.href,
      consent: true,
      fbp: readCookie("_fbp"),
      fbc: readCookie("_fbc"),
      value: data.value ?? null,
      currency: data.currency || "TRY",
      content_name: data.content_name || null,
    });
    return res.data;
  } catch {
    return { sent: false, reason: "server_error", event_id: id };
  }
};
